// @view/panels/authentication/PasswordResetCompleteBody.panel.tsx
import React from "react";
import type { PasswordResetCompletePhase } from "@ps-bridge/models/ui/passwordResetCompletePhase";
import type { PasswordResetCompleteViewProps } from "@ps-bridge/contracts/passwordResetComplete";
import PasswordResetCompleteFormView from "@view/authentication/PasswordResetCompleteForm.view";
import PasswordResetCompleteMissingTokenView from "@view/authentication/PasswordResetCompleteMissingToken.view";

type PasswordResetCompleteBodyPanelProps = Pick<
  PasswordResetCompleteViewProps,
  "password" | "confirmPassword" | "onPasswordChange" | "onConfirmPasswordChange" | "onSubmit"
> & {
  phase: PasswordResetCompletePhase;
};

const PasswordResetCompleteBodyPanel: React.FC<PasswordResetCompleteBodyPanelProps> = ({
  phase,
  password,
  confirmPassword,
  onPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
}) => {
  const phaseKeys = {
    form: "form",
    missingToken: "missingToken",
  } as const satisfies Record<PasswordResetCompletePhase, PasswordResetCompletePhase>;

  const render = {
    [phaseKeys.form]: (
      <PasswordResetCompleteFormView
        password={password}
        confirmPassword={confirmPassword}
        onPasswordChange={onPasswordChange}
        onConfirmPasswordChange={onConfirmPasswordChange}
        onSubmit={onSubmit}
      />
    ),
    [phaseKeys.missingToken]: <PasswordResetCompleteMissingTokenView />,
  } as const satisfies Record<PasswordResetCompletePhase, React.ReactElement>;

  return render[phase as keyof typeof render];
};

export default React.memo(PasswordResetCompleteBodyPanel, (prevProps, nextProps) => {
  return (
    prevProps.phase === nextProps.phase &&
    prevProps.password === nextProps.password &&
    prevProps.confirmPassword === nextProps.confirmPassword
  );
});
